module.exports = __webpack_public_path__ + "static/iso14001-fa6c1dd3b42b5e9c24d89dc3bc241c0a.svg";